import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { RepairWorkDto, RepairWorkReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getRepairWorkOptionTitle } from "./RepairWorkAutocomplete";

export interface RepairWorkInlineProps extends BaseEntityInlineInheritableProps {
  entity: RepairWorkDto | RepairWorkReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function RepairWorkInline({
  entity,
  entityId,
  ...otherProps
}: RepairWorkInlineProps) {
  const request = useApiRequest(
    apiClient.repairWorkApi.apiV1RepairWorkRepairWorkIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      repairWorkId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );

  entity = request?.data || entity;

  const full = entity as RepairWorkDto;
  // const ref = entity as RepairWorkReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={request}
      icon={<AppIcon of='repairWork' inText />}
      content={<>{full && getRepairWorkOptionTitle(full)} </>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Repair work"}
    />
  );
}
